import React, { ReactNode } from 'react';

interface DashboardStatCardProps {
    icon: ReactNode;
    value: ReactNode;
    label: string;
    color: string; // Tailwind or CSS color class
    children?: ReactNode; // For progress bar, chart, etc.
}

const DashboardStatCard: React.FC<DashboardStatCardProps> = ({ icon, value, label, color, children }) => {
    return (
        <div className={`rounded-xl p-6 flex flex-col justify-between min-w-[220px] min-h-[140px] shadow-md ${color} relative overflow-hidden`}>
            <div className="flex items-center mb-2">
                <div className="mr-2 text-white text-xl">{icon}</div>
                <span className="text-white text-base font-semibold">{label}</span>
            </div>
            <div className="flex-1 flex flex-col justify-center items-start">
                <span className="text-3xl font-bold text-white mb-1">{value}</span>
                {children}
            </div>
        </div>
    );
};

export default DashboardStatCard; 